/**
 * GIF provider transport: plain fetch from the browser straight to KLIPY (its terms: requests and media loads come
 * from the end-user client; no proxy, no cache). URLs come from core `logic/gifs` (klipyListUrl / klipyShareUrl).
 * No credentials or cookies go to KLIPY, and no referrer beyond the origin.
 */
import { ApiFailure, type GifTransport } from "@bundle/core";

function failure(status: number, message: string): ApiFailure {
  if (status === 429) return new ApiFailure("rateLimited", 429, "rate_limited", message);
  if (status === 0 || status >= 500) return new ApiFailure(status === 0 ? "network" : "server", status, "provider", message);
  return new ApiFailure("invalid", status, "provider", message);
}

export const browserGifTransport: GifTransport = {
  async getJson(url) {
    let res: Response;
    try {
      res = await fetch(url, { headers: { accept: "application/json" }, credentials: "omit", referrerPolicy: "origin" });
    } catch (e) {
      throw failure(0, e instanceof Error ? e.message : "network error");
    }
    if (!res.ok) throw failure(res.status, res.statusText);
    return (await res.json()) as unknown;
  },
  async postJson(url, body) {
    try {
      await fetch(url, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(body),
        credentials: "omit",
        referrerPolicy: "origin",
        keepalive: true,
      });
    } catch {
      // Analytics pings are best effort.
    }
  },
};
